export class CommunicationsAPI {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }

  // ── Templates ──────────────────────────────────────────────

  getTemplates() {
    return this.apiClient.get('/api/v1/communications/sms/templates');
  }

  getTemplateById(id) {
    return this.apiClient.get(`/api/v1/communications/sms/templates/${id}`);
  }

  createTemplate(data) {
    return this.apiClient.post('/api/v1/communications/sms/templates', data);
  }

  updateTemplate(id, data) {
    return this.apiClient.patch(`/api/v1/communications/sms/templates/${id}`, data);
  }

  deleteTemplate(id) {
    return this.apiClient.delete(`/api/v1/communications/sms/templates/${id}`);
  }

  // ── Jobs ───────────────────────────────────────────────────

  createJob(data) {
    return this.apiClient.post('/api/v1/communications/sms/jobs', data);
  }

  getJobs(page = 1, limit = 20) {
    return this.apiClient.get(`/api/v1/communications/sms/jobs?page=${page}&limit=${limit}`);
  }

  getJobById(id) {
    return this.apiClient.get(`/api/v1/communications/sms/jobs/${id}`);
  }

  // ── Logs ───────────────────────────────────────────────────

  getJobLogs(jobId, page = 1, limit = 50) {
    return this.apiClient.get(
      `/api/v1/communications/sms/jobs/${jobId}/logs?page=${page}&limit=${limit}`,
    );
  }

  getLogById(logId) {
    return this.apiClient.get(`/api/v1/communications/sms/logs/${logId}`);
  }
}
